// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const fetchAuthSession = (amplify, options) => {
  return amplify.Auth.fetchAuthSession(options);
};
export { fetchAuthSession };
